import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';

import { DynamicGrid } from '../../models/dynamic.model';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { NavigationService } from '../../services/navigation.service';
import { BaseListComponent } from '../../models/base/base-list.component';
import { Search } from '../../models/search.model';
import { SearchService } from '../../services/search.service';
import { Router } from '@angular/router';
import { RowTools, RowToolEvent } from '../../models/row-tools.model';
import { DatePipe } from '@angular/common';
import { FormService } from '../../services/form.service';
import { SharedService } from '../../services/shared.service';
import { AccountService } from '../../services/account.service';
import { Subject, takeUntil } from 'rxjs';

interface SuperSearchTabState {
  entity: 'order' | 'carrier';
  first: number;
  rows: number;
  sortField: string | null;
  sortOrder: number;
  multiSortMeta: any[];
  rowCount: number;
  results: any[];
  rowToolsArr: any[];
  isDataLoaded: boolean;
  loaded: boolean;
}

@Component({
  selector: 'search-list',
  templateUrl: 'search-list.component.html',
  providers: [SearchService, FormService]
})
export class SearchListComponent extends BaseListComponent implements OnInit, OnDestroy {
  search: Search;
  entityName: string;
  subEntity: string;
  params:any = {};
  superSearchEntity:boolean= false
  public multiSortMeta: any = [];

  showOrderModal: boolean = false;
  showUserModal: boolean = false;
  showLocationModal: boolean = false;
  invoiceOrderNumber = null;
  @ViewChild("orderDialog", { static: false }) dialogRef: ElementRef;
  rowToolsArr = [];
  prevLazyLoadEvent: LazyLoadEvent | null = null;
  private destroy$ = new Subject<void>();
  isDataLoaded: boolean = false;
  isLoading: boolean = false;
  skipNextLazyLoad: boolean = false;

  // --- Super Search Tab View (Orders / Carriers) ---
  // Tabs activate only when Super Search is triggered with a carrierPhone value.
  superSearchTabs: boolean = false;
  activeTab: 'order' | 'carrier' = 'order';
  tabState: Record<'order' | 'carrier', SuperSearchTabState> = {
    order: SearchListComponent.buildEmptyTabState('order'),
    carrier: SearchListComponent.buildEmptyTabState('carrier'),
  };

  private static buildEmptyTabState(entity: 'order' | 'carrier'): SuperSearchTabState {
    return {
      entity,
      first: 0,
      rows: 50,
      sortField: null,
      sortOrder: 0,
      multiSortMeta: [],
      rowCount: 0,
      results: [],
      rowToolsArr: [],
      isDataLoaded: false,
      loaded: false,
    };
  }

  constructor(
    protected messageService: MessageService,
    private navigationService: NavigationService,
    private searchService: SearchService,
    private sharedService: SharedService,
    private formService: FormService,
    private datePipe: DatePipe,
    private accountService: AccountService,
    private router: Router) {
    super();
  }

  ngOnInit() {
    this.subs['editSub'] = this.navigationService.edit$.subscribe((res) => {
      this.showModal = false;
      if (res) {
        if (this.entityName == 'invoice') {
          this.invoiceOrderNumber = this.sharedService.getData("invoiceOrderNumber");
          this.showOrderModal = true;
        } else {
          const item = this.sharedService.getData("items");
          const event = {
            item,
            key: "edit",
            tool: {
              key: "edit",
              type: "link",
              label: "Edit"
            }
          };
          this.clickRowTools(event);
        }
      }
    });
    this.title = 'Search';
    this.class = 'search';

    this.model = new DynamicGrid<any>();
    this.model.columns = [];

    this.navigationService.showTopNav(true);
    this.navigationService.setTitle(this.title);
    this.navigationService.setLeftNav('search', 'search');
    this.navigationService.showButton(true);
    this.navigationService.clearButton();
    this.navigationService.showFilter(false, true);

    this.navigationService.setTitleAndSub({
      title: this.title,
      subtitle: '',
    });

    this.subs['filter'] = this.navigationService.filterSearch$.subscribe(f => {
      this.superSearchEntity = false
      this.superSearchTabs = false;
      this.search = f;
    });

    this.subs['entity'] = this.navigationService.searchEntity$.subscribe(e => {
      this.first = 0;
      this.entityName = e.entity;
      this.subEntity = e.subEntity;
      this.superSearchEntity = false;
      this.superSearchTabs = false;
      this.isDataLoaded = false;
      this.navigationService.setTitleAndSub({
        title: this.title,
        subtitle: '',
      });
    });

    this.subs['search'] = this.navigationService.searchClick$.subscribe(() => {
      this.superSearchEntity = false
      this.superSearchTabs = false;
      this.first = 0;
      this.changeEntity();
      // this.clickSearch();
    });

    this.subs['supersearch'] = this.navigationService.superSearch$.subscribe((superSearchData) => {
      this.superSearchEntity = true
      this.entityName = 'order';
      this.subEntity = null
      this.first = 0;
      this.params = {};
      this.params.ordernumber = superSearchData.value['ordernumber'] ? superSearchData.value['ordernumber'] : null
      this.params.contactLastName = superSearchData.value['contactLastName'] ? superSearchData.value['contactLastName'] : null
      this.params.customerPhone = superSearchData.value['customerPhone'] ? superSearchData.value['customerPhone'] : null
      this.params.carrierPhone = superSearchData.value['carrierPhone'] ? superSearchData.value['carrierPhone'] : null

      // Enable Orders / Carriers tabs only when carrier phone is the trigger
      this.superSearchTabs = !!this.params.carrierPhone;
      this.activeTab = 'order';
      this.tabState = {
        order: SearchListComponent.buildEmptyTabState('order'),
        carrier: SearchListComponent.buildEmptyTabState('carrier'),
      };

      // this.clickSearch(this.params);
      this.changeEntity(this.params)
    });

    this.subs['clickOrderButton'] = this.navigationService.clickNewOrder$.subscribe(() => {
      this.addOrder();
    });

    this.subs['clickUserButton'] = this.navigationService.clickNewUser$.subscribe(() => {
      this.addUser();
    });

    this.subs['clickLocationButton'] = this.navigationService.clickNewLocation$.subscribe(s => {
      this.addLocation();
    });
    this.subs['loadList'] = this.navigationService.loadList$.subscribe(res => {
      if (res) {
        this.load(this.params);
      }
    });

  }

  ngOnDestroy() {
    this.safeUnsub('search');
    this.safeUnsub('entity');
    this.safeUnsub('clickOrderButton');
    this.safeUnsub('clickUserButton');
    this.safeUnsub('clickLocationButton');
    this.safeUnsub('filter');
    this.safeUnsub('editSub');
    this.safeUnsub('loadList');
    this.safeUnsub('supersearch');
    this.safeUnsub('searchList')
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeEntity(customParams?:any) {
    this.params = {};
    this.multiSortMeta = [];
    this.rowToolsArr = [];




    if(this.superSearchEntity){
      this.params = {...customParams}
    }else{
      this.params = {};
    }
    let entity = this.subEntity == null ? (this.superSearchEntity ? 'supersearch': this.entityName ) : (this.superSearchEntity ? 'supersearch': this.subEntity)


    switch (entity.toLowerCase()) {
      case 'supersearch':
      case 'order':
        this.applySuperSearchTabColumns(this.superSearchTabs ? this.activeTab : 'order');
        break;
      case 'location':

        this.model.clearCols();
        this.model.addHidden('id');
        this.model.addHidden('isUserLocation');
        this.model.addCol('text', 'fullName', 'Name', 160);
        this.model.addCol('text', 'city', 'City', 120);
        this.model.addCol('text', 'stateCode', 'State', 64);
        this.model.addCol('text', 'zip', 'Zip', 72);
        this.model.addCol('text', 'address1', 'Address', 200);

        break;
      case 'user':
      case 'carrier':
      case 'customer':

        this.model.clearCols();
        this.model.addHidden('id');
        this.model.addCol('text', 'email', 'Email', 160);
        this.model.addCol('text', 'fullName', 'Name', 220);
        this.model.addCol('text', 'allowLoginStatus', 'Allow Login', 120);
        this.model.addCol('text', 'roleName', 'Role', 120);
        this.model.addCol('text', 'updatedByName', 'Updated By', 160);
        this.model.addCol('datetime', 'updatedOn', 'Updated On', 140);

        break;
      case 'agent':
        this.model.clearCols();
        this.model.addHidden('id');
        this.model.addCol('text', 'email', 'Email', 160);
        this.model.addCol('text', 'fullName', 'Name', 220);
        this.model.addCol('text', 'allowLoginStatus', 'Allow Login', 120);
        this.model.addCol('text', 'canBeAssignedRepStatus', 'Can Be Assigned Rep', 120);
        this.model.addCol('text', 'roleName', 'Role', 120);
        this.model.addCol('text', 'updatedByName', 'Updated By', 160);
        this.model.addCol('datetime', 'updatedOn', 'Updated On', 140);

        break;
      case 'invoice':

        this.model.clearCols();
        this.model.addHidden('id');
        this.model.addCol('text', 'number', 'Order');
        this.model.addCol('text', 'actualDeliveryDate', 'Actual Delivery Date');
        this.model.addCol('text', 'billTo', 'Bill To');
        this.model.addCol('text', 'customerChargedTypeLabel', 'Customer Charged Type');
        this.model.addCol('currency', 'price', 'Total Cost');
        this.model.addCol('currency', 'deposit', 'Deposit');
        this.model.addCol('currency', 'balanceDue', 'Balance');
        this.model.addCol('text', 'fscPaymentStatusName', 'FSC Payment Status');
        this.model.addCol('text', 'carrierName', 'Carrier Name');
        this.model.addCol('currency', 'finalcarrierpayment', 'Final Carrier Payment');
        this.model.addCol('text', 'carrierPaidStatusName', 'Is Carrier Paid');
        this.model.addCol('date', 'paymentScheduledDate', 'Scheduled Payment Date');
        this.model.addCol('date', 'carrierPaidDate', 'Carrier Paid Date');
        break;
    }

    this.skipNextLazyLoad = true;
    if (this.superSearchTabs) {
      this.loadSuperSearchBothTabs();
    } else {
      this.load(this.params);
    }
  }

  clickSearch(customParams?:any) {
    this.load(customParams);
  }

  save(event) {
    this.cancel(event);
    this.changeEntity(this.params); // or load();
  }

  setParams(customParams?:any) {
    let params = {};

    if(this.superSearchEntity && customParams){
      params = {...customParams}
    } else if (this.search != null && this.search.filters != null && this.search.filters.length > 0) {
      this.search.filters.forEach(f => {
        if (f.value != null && f.value != '') {
          params[f.key] = f.value
        }
      })
    }

    this.router.navigate([], { queryParams: params });
    this.params = params;
  }

  setRowTools(item: any) {
    this.rowTools = new RowTools();
    if (this.superSearchTabs && this.activeTab === 'carrier') {
      if (this.sharedService.getPermissions("can_delete")) {
        this.rowTools.addKebob("delete", "Delete");
      }
      if (this.sharedService.getPermissions("carriers_edit") || this.sharedService.getPermissions("carriers")) {
        this.rowTools.addLink("edit", "View");
      }
      this.rowToolsArr.push(this.rowTools);
      return;
    }
    if (this.entityName == "order") {
      if (item.allowEdit && ((this.sharedService.getPermissions("orders_edit") && item?.orderStatus!=6) || (this.sharedService.getPermissions("completedmoves_edit") && item?.orderStatus==6 ))) {
        this.rowTools.addLink("edit", "Edit");
      }
      if ((this.sharedService.getPermissions("orders") && item?.orderStatus!=6 ) || (this.sharedService.getPermissions("completedmoves")  && item?.orderStatus==6) ) {
        this.rowTools.addLink("view", "View");
      }
    } else if (this.entityName == "invoice") {
      if (item.allowEdit && this.sharedService.getPermissions("invoices")) {
        this.rowTools.addLink("view", "View");
      }
    } else if (
      (this.entityName == "user" && item.roleId == 3) ||
      this.entityName == "agent"
    ) {
      if (this.sharedService.getPermissions("can_delete") && (item.id!=3 && item.id!=5864 && item.id!= 5865)) {
        this.rowTools.addKebob("delete", "Delete");
      }
      if (this.sharedService.getPermissions("agents") || this.sharedService.getPermissions("agents_edit")) {
        this.rowTools.addLink("edit", "View");
      }
    } else if (
      (this.entityName == "user" && item.roleId == 2) ||
      this.entityName == "carriers"
    ) {
      if (this.sharedService.getPermissions("can_delete")) {
        this.rowTools.addKebob("delete", "Delete");
      }
      if (this.sharedService.getPermissions("carriers_edit") || this.sharedService.getPermissions("carriers")) {
        this.rowTools.addLink("edit", "View");
      }
    } else if (
      (this.entityName == "user" && item.roleId == 1) ||
      this.entityName == "customers"
    ) {
      if (this.sharedService.getPermissions("can_delete")) {
        this.rowTools.addKebob("delete", "Delete");
      }
      if (this.sharedService.getPermissions("customers_edit") || this.sharedService.getPermissions("customers")) {
        this.rowTools.addLink("edit", "View");
      }
    } else if (this.entityName == "location") {
      if (this.sharedService.getPermissions("can_delete")) {
        this.rowTools.addKebob("delete", "Delete");
      }
      if (this.sharedService.getPermissions("locations_edit") || this.sharedService.getPermissions("locations")) {
        this.rowTools.addLink("edit", "View");
      }
    } else {
      this.rowTools.addKebob("delete", "Delete");
      this.rowTools.addLink("edit", "Edit");
      this.rowTools.addLink("view", "View");
    }
    this.rowToolsArr.push(this.rowTools);
  }

  lazyLoad(e: any) {
    if (this.skipNextLazyLoad) {
      this.skipNextLazyLoad = false;
      this.prevLazyLoadEvent = e;
      return;
    }
    if (this.prevLazyLoadEvent && this.sharedService.isSameEvent(e, this.prevLazyLoadEvent)) {
      return;
    }
    setTimeout(() => {
      this.prevLazyLoadEvent = e;
      if (e.multiSortMeta !== undefined && e.multiSortMeta.length > 0) {
      e.multiSortMeta.map((sort) => {
        const sortIndex = this.multiSortMeta.findIndex((f: any) => { return f.field === sort.field; });
        if (sortIndex > -1) {
          if (this.multiSortMeta[sortIndex].order !== sort.order) {
            this.multiSortMeta[sortIndex].requireReload = true
          }
          this.multiSortMeta[sortIndex].order = sort.order;
        } else {
          this.multiSortMeta.push({ field: sort.field, order: sort.order, requireReload: true });
        }
      });

      // Check if any of colum require reload
      const requireReload = this.multiSortMeta.some((m: any) => {
        return m.requireReload;
      });

      // It will reload only when a new sort column is added or the previous one is altered
      if (requireReload) {
        this.multiSortMeta.forEach((m: any) => {
          return m.requireReload = false;
        });
        this.multiSortMeta = [...this.multiSortMeta];
        this.setGridState(e);
        this.load(this.params);
      }
    } else {
      this.setGridState(e);
      this.load(this.params);
      //this.load();
    }
    }, 0);
  }

  load(customParams?:any) {
    console.log("search",this.search)
    if (this.search == null)
      return;

    this.setParams(customParams);

    let entity = this.superSearchTabs
      ? (this.activeTab === 'order' ? 'supersearch' : 'carriersupersearch')
      : (this.subEntity == null
          ? (this.superSearchEntity ? 'supersearch': this.entityName)
          : (this.superSearchEntity ? 'supersearch': this.subEntity));

    // Carrier tab only needs the carrier phone; orders tab uses full supersearch params
    const requestParams = (this.superSearchTabs && this.activeTab === 'carrier')
      ? { carrierPhone: this.params.carrierPhone }
      : this.params;

    this.isLoading = true;
    this.model.rows = [];
    // this.search.query = this.superSearchEntity ? null : this.search.query

    const fieldNameObj = {
      'customerExpectedPickupDates': 'FirstcustomerExpectedPickup',
      'customerExpectedDeliveryDates': 'FirstcustomerExpectedDelivery',
      'carrierScheduledPickupDates': 'Firstcarrierscheduledpickup',
      'carrierScheduledDeliveryDates': 'Firstcarrierscheduleddelivery',
      'pickupNewETADates': 'FirstpickupNewETADate',
      'deliveryNewETADates': 'FirstdeliveryNewETADate'
    }
    const updatedMultiSortMeta = this.multiSortMeta.map((e) => {
      return { ...e, field: fieldNameObj[e.field] ? fieldNameObj[e.field] : e.field };
    })
    this.rowCount = this.first == 0 ? 0 : this.rowCount
    this.subs['searchList']= this.searchService
      .search(
        entity,
        requestParams,
        this.search.query,
        this.first,
        this.rows,
        this.sortField,
        this.sortOrder,
        JSON.stringify(updatedMultiSortMeta),
        this.search.duration,
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (r) => {
          this.isLoading = false;
          this.isDataLoaded = true;
          this.rowToolsArr = [];
          r.body.results.forEach((data: any) => this.setRowTools(data));
          this.rowCount = r.body.count;

          if (this.superSearchTabs) {
            const otherTab = this.activeTab === 'order' ? 'carrier' : 'order';
            const combinedTotal = r.body.count + (this.tabState[otherTab].rowCount ?? 0);
            this.navigationService.setTitleAndSub({ title: this.title, subtitle: combinedTotal + ' total' });
          } else {
            this.navigationService.setTitleAndSub({
              title: this.title,
              subtitle: this.rowCount + " total",
            });
          }

          this.model.rows = (this.superSearchTabs && this.activeTab === 'carrier')
            ? this.processCarrierData(r.body.results)
            : this.processOrderData(r.body.results);

          if (this.superSearchTabs) {
            this.snapshotActiveTab(true);
          }
        },
        (e) => {
          this.isLoading = false;
          const errorMessage = e?.error?.message || e?.message || 'An error occurred while searching';
          this.messageService.add({
            severity: 'error',
            summary: 'Search Error',
            detail: errorMessage,
            life: 5000,
            closable: false,
          });
        }
      );


  }

  // --- Super Search Tab View helpers ---

  switchTab(tab: 'order' | 'carrier') {
    if (!this.superSearchTabs || this.activeTab === tab) return;
    // Snapshot current active tab state
    this.snapshotActiveTab(true);
    // Switch
    this.activeTab = tab;
    this.entityName = tab;
    this.subEntity = null;
    this.prevLazyLoadEvent = null;
    // Reset pagination and sorting on tab switch
    this.first = 0;
    this.rows = 50;
    this.sortField = null;
    this.sortOrder = 0;
    this.multiSortMeta = [];
    const s = this.tabState[tab];
    this.rowCount = s.rowCount;
    this.model.rows = s.results;
    this.rowToolsArr = s.rowToolsArr;
    this.isDataLoaded = s.isDataLoaded;
    // Apply columns for the target tab (triggers lazyLoad; skip it so we don't double-call)
    this.skipNextLazyLoad = true;
    this.applySuperSearchTabColumns(tab);
    this.load(this.params);
  }

  private snapshotActiveTab(loaded: boolean) {
    if (!this.superSearchTabs) return;
    const s = this.tabState[this.activeTab];
    s.first = this.first;
    s.rows = this.rows;
    s.sortField = this.sortField;
    s.sortOrder = this.sortOrder;
    s.multiSortMeta = [...this.multiSortMeta];
    s.rowCount = this.rowCount;
    s.results = this.model.rows;
    s.rowToolsArr = this.rowToolsArr;
    s.isDataLoaded = this.isDataLoaded;
    if (loaded) {
      s.loaded = true;
    }
  }

  private applySuperSearchTabColumns(tab: 'order' | 'carrier') {
    if (tab === 'order') {
      this.model.clearCols();
      this.model.addHidden('id');
      this.model.addCol('text', 'number', 'No.', 70);
      this.model.addCol('text', 'customerBusinessName', 'Customer Name', 160);
      this.model.addCol('text', 'createdOn', 'Created On', 80);
      this.model.addCol('textarea', 'makemodel', 'Make/Model', 160);
      this.model.addCol('text', 'pickupCityState', 'Pickup', 110);
      this.model.addCol('text', 'deliveryCityState', 'Delivery', 110);
      this.model.addCol('text', 'numberOfVehicles', '#', 40);
      this.model.addCol('currency', 'price', 'Price', 90);
      this.model.addCol('currency', 'priceToCarrier', 'Price To Carrier', 90);
      this.model.addCol('text', 'assignedCarrierName', 'Carrier', 160);
      this.model.addCol('textarea', 'customerExpectedPickupDates', 'Customer Expected Pickup', 160);
      this.model.addCol('textarea', 'carrierScheduledPickupDates', 'Carrier Scheduled Pickup', 160);
      this.model.addCol('textarea', 'pickupNewETADates', 'New Pickup ETA ', 160);
      this.model.addCol('textarea', 'customerExpectedDeliveryDates', 'Customer Expected Delivery', 160);
      this.model.addCol('textarea', 'carrierScheduledDeliveryDates', 'Carrier Scheduled Delivery', 160);
      this.model.addCol('textarea', 'deliveryNewETADates', ' New Delivery ETA', 160);
      this.model.addCol('text', 'openEnclosedName', 'Open/Enclosed', 130);
      this.model.addCol('text', 'operability', 'Operability', 160);
      this.model.addCol('text', 'poNumber', 'PO Number', 160);
      this.model.addCol('text', 'callback1date_only', 'Pickup Callback Date', 90);
      this.model.addCol('text', 'callback1time_only', 'Pickup Callback Time', 90);
      this.model.addCol('text', 'callback2date_only', 'Delivery Callback Date', 90);
      this.model.addCol('text', 'callback2time_only', 'Delivery Callback Time', 90);
    } else {
      this.model.clearCols();
      this.model.addHidden('id');
      this.model.addCol('text', 'carrierUploadCompleteValue', 'Profile Complete', 100);
      this.model.addCol('text', 'fullName', 'Company Name', 150);
      this.model.addCol('text', 'mcDotNumber', 'MC#', 120);
      this.model.addCol('text', 'city', 'Business City', 150);
      this.model.addCol('text', 'stateCode', 'Business State', 100);
      this.model.addCol('text', 'totalMoves', 'Total Moves Assigned', 150);
      this.model.addCol('text', 'alltimeontimePer', 'All Time On Time %', 120);
      this.model.addCol('text', 'top10OntimePer', 'Last Ten Moves On Time %', 120);
      this.model.addCol('text', 'dateoverhaulOntimePer', 'Since Date Overhaul On Time %', 120);
      this.model.addCol('text', 'alltimeCarrierCancellationPer', 'All Time Carrier Cancellation %', 120);
      this.model.addCol('text', 'top10CancelPer', 'Last Ten Moves Carrier Cancellation %', 120);
      this.model.addCol('text', 'dateoverhaulCarrierCancelledPer', 'Since Date Overhaul Carrier Cancellation %', 120);
    }
  }


  private updateCombinedSubtitle() {
    const total = (this.tabState.order.rowCount ?? 0) + (this.tabState.carrier.rowCount ?? 0);
    this.navigationService.setTitleAndSub({ title: this.title, subtitle: total + ' total' });
  }

  private buildRowToolsForTab(items: any[], tab: 'order' | 'carrier'): any[] {
    const savedActiveTab = this.activeTab;
    const savedEntityName = this.entityName;
    const savedRowToolsArr = this.rowToolsArr;
    this.activeTab = tab;
    this.entityName = 'order';
    this.rowToolsArr = [];
    items.forEach(item => this.setRowTools(item));
    const result = [...this.rowToolsArr];
    this.activeTab = savedActiveTab;
    this.entityName = savedEntityName;
    this.rowToolsArr = savedRowToolsArr;
    return result;
  }

  private processOrderData(results: any[]): any[] {
    return results.map(data => {
      data.customerExpectedPickupDates = data.customerExpectedPickupDates?.replaceAll("\\n", "\n");
      data.customerExpectedDeliveryDates = data.customerExpectedDeliveryDates?.replaceAll("\\n", "\n");
      data.carrierScheduledPickupDates = data.carrierScheduledPickupDates?.replaceAll("\\n", "\n");
      data.carrierScheduledDeliveryDates = data.carrierScheduledDeliveryDates?.replaceAll("\\n", "\n");
      data.pickupNewETADates = data.pickupNewETADates?.replaceAll("\\n", "\n");
      data.deliveryNewETADates = data.deliveryNewETADates?.replaceAll("\\n", "\n");
      data.carrierTransportResultsList = data.carrierTransportResultsList?.replaceAll("\\n", "\n");
      data.fscTransportResultsList = data.fscTransportResultsList?.replaceAll("\\n", "\n");
      let deliveryDate = null;
      if (data.actualDeliveryDate) {
        const dateParts = data.actualDeliveryDate.split('-');
        deliveryDate = dateParts.length === 3
          ? new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
          : new Date(data.actualDeliveryDate);
      }
      data.actualDeliveryDate = deliveryDate && !isNaN(deliveryDate.getTime())
        ? `${String(deliveryDate.getMonth() + 1).padStart(2, '0')}/${String(deliveryDate.getDate()).padStart(2, '0')}/${String(deliveryDate.getFullYear() % 100).padStart(2, '0')}`
        : null;
      let createDate = data.createdOn ? new Date(data.createdOn) : null;
      data.createdOn = createDate
        ? `${String(createDate.getMonth() + 1).padStart(2, '0')}/${String(createDate.getDate()).padStart(2, '0')}/${String(createDate.getFullYear() % 100).padStart(2, '0')}`
        : null;
      data.makemodel = data.makemodel?.replaceAll("\\n", "\n");
      let date = data.callback1time_only ? new Date(data.callback1time_only) : null;
      data.callback1time_only = date
        ? date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" })
        : null;
      let date1 = data.callback2time_only ? new Date(data.callback2time_only) : null;
      data.callback2time_only = date1
        ? date1.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" })
        : null;
      data.callback1date_only = date
        ? `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${String(date.getFullYear() % 100).padStart(2, '0')}`
        : null;
      data.callback2date_only = date1
        ? `${String(date1.getMonth() + 1).padStart(2, '0')}/${String(date1.getDate()).padStart(2, '0')}/${String(date1.getFullYear() % 100).padStart(2, '0')}`
        : null;
      return data;
    });
  }

  private processCarrierData(results: any[]): any[] {
    return results.map(data => {
      data.totalMoves = data.totalMoves ?? 0;
      data.top10OntimePer = (data.top10OntimePer ?? 0) + "%  (" + (data.top10Ontime ?? 0) + ")";
      data.top10CancelPer = (data.top10CancelPer ?? 0) + "%  (" + (data.top10Cancel ?? 0) + ")";
      data.dateoverhaulOntimePer = (data.dateoverhaulOntimePer ?? 0) + "%  (" + (data.dateoverhaulOntime ?? 0) + ")";
      data.dateoverhaulCarrierCancelledPer = (data.dateoverhaulCarrierCancelledPer ?? 0) + "%  (" + (data.dateoverhaulCarrierCancelled ?? 0) + ")";
      data.alltimeontimePer = (data.allTimeOntimePer ?? 0) + "%  (" + (data.allTimeOntime ?? 0) + ")";
      data.alltimeCarrierCancellationPer = (data.allTimeCarrierCancellationPer ?? 0) + "%  (" + (data.allTimeCarrierCancellation ?? 0) + ")";
      return data;
    });
  }

  private loadSuperSearchBothTabs() {
    if (this.search == null) return;
    this.setParams(this.params);
    this.isLoading = true;
    this.isDataLoaded = false;
    this.model.rows = [];
    const fieldNameObj = {
      'customerExpectedPickupDates': 'FirstcustomerExpectedPickup',
      'customerExpectedDeliveryDates': 'FirstcustomerExpectedDelivery',
      'carrierScheduledPickupDates': 'Firstcarrierscheduledpickup',
      'carrierScheduledDeliveryDates': 'Firstcarrierscheduleddelivery',
      'pickupNewETADates': 'FirstpickupNewETADate',
      'deliveryNewETADates': 'FirstdeliveryNewETADate',
    };
    const updatedMultiSortMeta = this.multiSortMeta.map(e => ({
      ...e, field: fieldNameObj[e.field] ? fieldNameObj[e.field] : e.field,
    }));
    const errorHandler = (e: any) => {
      this.messageService.add({
        severity: 'error', summary: 'Search Error',
        detail: e?.error?.message || e?.message || 'An error occurred while searching',
        life: 5000, closable: false,
      });
    };
    this.searchService.search(
      'supersearch', this.params, this.search.query,
      this.first, this.rows, this.sortField, this.sortOrder,
      JSON.stringify(updatedMultiSortMeta), this.search.duration,
    ).pipe(takeUntil(this.destroy$)).subscribe(r => {
      const results = this.processOrderData(r.body.results);
      const rowToolsArr = this.buildRowToolsForTab(results, 'order');
      this.tabState.order.results = results;
      this.tabState.order.rowCount = r.body.count;
      this.tabState.order.rowToolsArr = rowToolsArr;
      this.tabState.order.isDataLoaded = true;
      this.tabState.order.loaded = true;
      if (this.activeTab === 'order') {
        this.model.rows = results;
        this.rowToolsArr = rowToolsArr;
        this.rowCount = r.body.count;
        this.isDataLoaded = true;
        this.isLoading = false;
      }
      this.updateCombinedSubtitle();
    }, (e) => { this.isLoading = false; errorHandler(e); });
    this.searchService.search(
      'carriersupersearch', { carrierPhone: this.params.carrierPhone }, this.search.query,
      this.first, this.rows, this.sortField, this.sortOrder,
      JSON.stringify([]), this.search.duration,
    ).pipe(takeUntil(this.destroy$)).subscribe(r => {
      const results = this.processCarrierData(r.body.results);
      const rowToolsArr = this.buildRowToolsForTab(results, 'carrier');
      this.tabState.carrier.results = results;
      this.tabState.carrier.rowCount = r.body.count;
      this.tabState.carrier.rowToolsArr = rowToolsArr;
      this.tabState.carrier.isDataLoaded = true;
      this.tabState.carrier.loaded = true;
      if (this.activeTab === 'carrier') {
        this.model.rows = results;
        this.rowToolsArr = rowToolsArr;
        this.rowCount = r.body.count;
        this.isDataLoaded = true;
        this.isLoading = false;
      }
      this.updateCombinedSubtitle();
    }, (e) => { this.isLoading = false; errorHandler(e); });
  }

  clickRowTools(event: RowToolEvent) {
    this.selection = event.item;
    if (this.superSearchTabs && this.activeTab === 'carrier') {
      if (event.key === 'edit') {
        this.showUserModal = true;
      } else if (event.key === 'delete') {
        this.isDeleting = true;
      }
      return;
    }
    this.entityName = this.superSearchEntity ? 'order' : this.entityName;
    switch (event.key) {
      case 'view':
        if (this.entityName == 'order') {
          this.sharedService.setData("items", event.item);
        }
        this.view(event.item);
        break;
      case 'edit':
        this.edit(event.item);
        if (this.entityName == 'order') {
          this.sharedService.setData("items", event.item);
        }
        break;
      case 'delete':
        this.isDeleting = true;
        break;
    }
  }

  view(item:any) {
    if (this.entityName == "invoice") {
      if (item?.isBulkUploadInvoiceActive) {
        this.messageService.add(
          this.toast(
            true,
            "Invoice cannot be edited as " +
              item?.bulkUploadInvoiceBy +
              " is Bulk Editing"
          )
        );
        return;
      }
    }
    this.navigationService.setDetail(this.entityName, item.guid);
  }

  rowChangePreview(id: string) {
    if (this.navigationService.getNav().showRightNav) {
      this.navigationService.setRightNav(this.entityName, id);
    }
  }

  edit(row: any) {
    this.selection = row;

    switch (this.entityName) {
      case 'order':
        if (row?.isBulkUploadActive) {
          this.messageService.add(this.toast(true, 'Order cannot be edited as ' + row?.bulkUploadBy + ' is Bulk Dispatching'));
          return;
        }
        this.showOrderModal = true;
        break;
      case 'location':
        this.showLocationModal = true;
        break;
      case 'user':
        this.showUserModal = true;
        break;
      case 'invoice':
        this.navigationService.setLeftNav('menu', 'invoice')
        this.router.navigate(['/invoices'], { queryParams: { show: row.id } });
        break;
    }
  }

  addUser() {
    this.selection = null;
    this.showUserModal = true;
    this.showOrderModal = false;
    this.showLocationModal = false;
    this.isAdding = true;
  }

  addOrder() {
    this.selection = null;
    this.showUserModal = false;
    this.showOrderModal = true;
    this.showLocationModal = false;
    this.isAdding = true;
  }

  addLocation() {
    this.selection = null;
    this.showOrderModal = false;
    this.showUserModal = false;
    this.showLocationModal = true;
  }

  revert(event){
    if (event) {
      this.load(this.params);
    }
  }

   onUserSaveComplete(event: any) {
    this.changeEntity(this.params); 
    if (this.isAdding) {
      this.cancel(event);
    }
  }

  cancel(orderId?:any) {
    this.showModal = false;
    if(typeof orderId == 'boolean' && orderId == false){
      this.showOrderModal = true;
    }
    else{
      this.showOrderModal = false;
    }
    this.showUserModal = false;
    this.isEditing = false;
    this.isAdding = false;
    this.isDeleting = false;
    this.showLocationModal = false;
    if (orderId?.length > 0) {
      this.accountService.setAllowOrdersEdit(orderId?.map((res) => res)).subscribe(r => {
      });
    }
  }
  cancelDelete() {
    this.isDeleting = false;
  }

  delete(urlString: string) {
    const deleteKey = urlString === 'carrier' ? 'user' : urlString;
    if (this.selection != null) {
      this.formService
        .delete(deleteKey, this.selection.guid)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (r) => {
            this.isDeleting = false;
            this.selection = null;
            this.messageService.add(this.toast(true, r.message));
            this.sharedService
              .getMenuCount("users")
              .subscribe((res) => {
                this.navigationService.menuCountChange(res.body, "users");
              });
            this.sharedService
              .getMenuCount("tenderslocations")
              .subscribe((res) => {
                this.navigationService.menuCountChange(
                  res.body,
                  "tenderslocations"
                );
              });
            this.load(this.superSearchEntity ? this.params : undefined);
          },
          (err) => {
            let msg = "Error occurred";
            if (err && err.error && err.error.message) {
              this.isDeleting = false;
              msg = err.error.message;
            }
            this.messageService.add(this.toast(false, msg));
            console.error(err);
          }
        );
    }
  }

  rowColor(item: any): string {
    if (item.isCanceled && item.cancelationType === 1) {
      return "rgba(250, 0, 0, 0.1)";
    } else if (item.isCanceled || item.cancelationType === 2) {
      return "#ff0000b0";
    } else if (item.actionRequired) {
      return "rgba(250, 250, 0, 0.1)";
    } else if (item.colourCode) {
      return item.colourCode;
    } else {
      return null;
    }
  }

  getColumnStyle(col, item) {
    if(col.key=='fullName'){
     if (item.carrierStatus) {
       switch (item.carrierStatus) {
         case 1:
          item.colourCode=null;
           return '#7CFC00';
         case 2:
           return null;
         case 3:
           item.colourCode=null;
           return '#ffff00';
         case 4:
           item.colourCode=null;
           return '#ffa500';
         case 5:
           item.colourCode=null;
           return '#f44336';
         default:
           return null;
       }
     }

     return null;
    }
   }

  private isDarkMode(): boolean {
    return localStorage.getItem('isDarkMode') === 'true';
  }

  getColumnTextColor(col, item): string {
    if (col.key == 'fullName' && item.carrierStatus && this.isDarkMode()) {
      switch (item.carrierStatus) {
        case 1: return '#212121';
        case 3: return '#212121';
        case 4: return '#ffffff';
        case 5: return '#212121';
        default: return null;
      }
    }
    return null;
  }
}
